<template>
  <div>
    <Movementmenu />

    <v-container fluid class="pa-6" tag="section">
      <v-row class="mb-2">
        <v-col cols="12">
          <h2 class="text-h4 font-weight-bold mb-2 primary--text">
            <v-icon large color="primary" class="mr-2">mdi-chart-box</v-icon>
            สรุปผลการประมวลผลการย้าย
          </h2>
          <div class="subtitle-1 grey--text text--darken-1">
            ข้อมูลสรุปและจัดการสถานะการย้ายประจำรอบ
            {{ periods.period_times }}/{{ periods.period_year }}
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #1976D2"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">รายการทั้งหมด</div>
                <div class="text-h4 font-weight-bold">{{ stats.total }}</div>
              </div>
              <v-avatar color="blue lighten-5" size="60">
                <v-icon color="blue" x-large>mdi-file-document-multiple</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #4CAF50"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">ย้ายปกติ (Agree)</div>
                <div class="text-h4 font-weight-bold success--text">
                  {{ stats.agree }}
                </div>
              </div>
              <v-avatar color="green lighten-5" size="60">
                <v-icon color="success" x-large>mdi-check-circle</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #FF9800"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">ตัดโอน (Transfer)</div>
                <div class="text-h4 font-weight-bold warning--text">
                  {{ stats.transfer }}
                </div>
              </div>
              <v-avatar color="orange lighten-5" size="60">
                <v-icon color="warning" x-large>mdi-scissors-cutting</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #00BCD4"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">สับเปลี่ยน (Swap)</div>
                <div class="text-h4 font-weight-bold cyan--text">
                  {{ stats.swap }}
                </div>
              </div>
              <v-avatar color="cyan lighten-5" size="60">
                <v-icon color="cyan" x-large>mdi-swap-horizontal-bold</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-card elevation="2" class="rounded-lg mb-4">
        <v-toolbar flat color="white" class="pt-2">
          <v-row align="center">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="ค้นหา ชื่อ, วิทยาลัย, หรือรหัส..."
                single-line
                hide-details
                outlined
                dense
                rounded
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="2">
              <v-select
                v-model="times_select"
                :items="time_ss"
                label="ครั้งที่"
                outlined
                dense
                hide-details
                rounded
              ></v-select>
            </v-col>
            <v-col cols="6" md="2">
              <v-select
                v-model="years_select"
                :items="year_ss"
                label="ปีงบประมาณ"
                outlined
                dense
                hide-details
                rounded
              ></v-select>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="primary"
                block
                rounded
                depressed
                @click="searchTimeYear"
              >
                <v-icon left>mdi-filter</v-icon> ค้นหา
              </v-btn>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="success"
                outlined
                block
                rounded
                @click="exportToExcel"
              >
                <v-icon left>mdi-file-excel</v-icon> Export
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>

        <v-expansion-panels flat accordion class="mt-2">
          <v-expansion-panel>
            <v-expansion-panel-header class="grey lighten-4">
              <span class="text-subtitle-2 grey--text text--darken-2">
                <v-icon small class="mr-2">mdi-table-cog</v-icon>
                ปรับแต่งคอลัมน์ตาราง
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pt-4">
              <v-select
                v-model="selectedHeaders"
                :items="headersMap"
                label="เลือกคอลัมน์ที่ต้องการแสดง"
                multiple
                outlined
                dense
                chips
                small-chips
                deletable-chips
                return-object
              ></v-select>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>

      <v-card elevation="2" class="rounded-lg">
        <v-data-table
          :headers="showHeaders"
          :items="conditons_transfer_successs"
          :search="search"
          :loading="loading"
          :item-class="row_classes"
          class="elevation-0"
          :items-per-page="10"
        >
          <template v-slot:item.ctsstatus_select="{ item }">
            <v-chip
              :color="getStatusColor(item.ctsstatus_select)"
              dark
              small
              label
            >
              {{ getStatusText(item.ctsstatus_select) }}
            </v-chip>
          </template>

          <template v-slot:item.college_name_new="{ item }">
            <div class="d-flex align-center">
              <v-icon color="success" small class="mr-1"
                >mdi-map-marker-right</v-icon
              >
              <span class="success--text font-weight-bold">{{
                item.college_name_new
              }}</span>
            </div>
          </template>

          <template v-slot:item.college_name_old="{ item }">
            <div class="grey--text text--darken-2">
              {{ item.college_name_old }}
            </div>
          </template>

          <template v-slot:item.actionCencel="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="red lighten-1"
                  v-bind="attrs"
                  v-on="on"
                  @click="
                    item.ctsstatus_select === 'transfer'
                      ? CencelMovementCut(item.ctsid_ref)
                      : CencelMovement(item.ctsid_ref)
                  "
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>ยกเลิก/ลบรายการนี้</span>
            </v-tooltip>
          </template>

          <template v-slot:item.id_branch="{ item }">
            <v-icon v-if="item.id_branch" color="success" small
              >mdi-check-circle</v-icon
            >
          </template>
          <template v-slot:item.service_status="{ item }">
            <v-icon
              v-if="item.service_status === 'service'"
              color="warning"
              small
              >mdi-star</v-icon
            >
          </template>
          <template v-slot:item.demand_college="{ item }">
            <v-icon
              v-if="item.ctsstatus_select === 'demand'"
              color="primary"
              small
              >mdi-hand-pointing-right</v-icon
            >
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="canceldialog" persistent max-width="700px">
        <v-card class="rounded-xl overflow-hidden">
          <v-toolbar color="red lighten-1" dark flat>
            <v-icon class="mr-2">mdi-alert-circle</v-icon> ยืนยันการยกเลิกรายการ
            <v-spacer></v-spacer>
            <v-btn icon @click="canceldialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>

          <v-card-text class="pt-6">
            <v-form ref="cancelform" lazy-validation>
              <v-alert border="left" colored-border type="error" elevation="2">
                คุณกำลังจะลบข้อมูลผลสำเร็จของการย้าย โปรดตรวจสอบความถูกต้อง
              </v-alert>

              <v-card outlined class="pa-4 mt-3">
                <div class="text-h6 mb-2">ข้อมูลบุคลากร</div>
                <v-simple-table dense>
                  <tbody>
                    <tr>
                      <td class="font-weight-bold grey--text">ชื่อ-สกุล</td>
                      <td>
                        {{ transference_personnels_id_ref.title_s
                        }}{{ transference_personnels_id_ref.frist_name }}
                        {{ transference_personnels_id_ref.last_name }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold grey--text">
                        รหัสบัตรประชาชน
                      </td>
                      <td>{{ transference_personnels_id_ref.id_card }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold grey--text">สถานศึกษาเดิม</td>
                      <td>
                        {{ transference_personnels_id_ref.college_name }} ({{
                          transference_personnels_id_ref.id_position
                        }})
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>

                <v-divider class="my-3"></v-divider>

                <div class="text-h6 mb-2">ข้อมูลปลายทาง</div>
                <div
                  v-if="
                    conditons_transfer_successsSelect.ctsstatus_select ===
                      'transfer'
                  "
                >
                  <v-chip color="orange" dark label small class="mb-2"
                    >ตัดโอนตำแหน่ง</v-chip
                  >
                  <div class="text-body-1">
                    ไปยัง:
                    <strong>{{
                      conditons_transfer_successsSelect.college_name_new
                    }}</strong>
                  </div>
                </div>
                <div v-else>
                  <v-chip color="green" dark label small class="mb-2"
                    >ย้ายปกติ/สับเปลี่ยน</v-chip
                  >
                  <div class="text-body-1">
                    วิทยาลัย:
                    <strong>{{ man_powerss.college_name || "ไม่ระบุ" }}</strong>
                  </div>
                  <div class="text-body-1">
                    เลขที่ตำแหน่ง:
                    <strong>{{ man_powerss.id_position || "ไม่ระบุ" }}</strong>
                  </div>
                </div>
              </v-card>
            </v-form>
          </v-card-text>

          <v-card-actions class="grey lighten-5 pa-4">
            <v-spacer></v-spacer>
            <v-btn text color="grey darken-1" @click="canceldialog = false"
              >ยกเลิก</v-btn
            >
            <v-btn
              color="red"
              dark
              elevation="2"
              @click="
                conditons_transfer_successsSelect.ctsstatus_select ===
                'transfer'
                  ? cancelCutSubmit()
                  : cancelSubmit()
              "
            >
              <v-icon left>mdi-delete</v-icon> ยืนยันการลบ
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      top
      right
    >
      <div class="d-flex align-center">
        <v-icon class="mr-2" dark>{{ snackbar.icon }}</v-icon>
        <span class="white--text">{{ snackbar.text }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn text dark v-bind="attrs" @click="snackbar.show = false"
          >ปิด</v-btn
        >
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Movementmenu from "../../components/admin/movementmenu.vue";
import * as XLSX from "xlsx"; // Requires npm install xlsx
import { saveAs } from "file-saver"; // Requires npm install file-saver

export default {
  name: "ConditionsTransferSuccess",
  components: { Movementmenu },
  data() {
    return {
      ApiKey: "HRvec2021",
      loading: false,
      search: "",

      // Selectors
      times_select: "",
      years_select: "",
      time_ss: [1, 2],
      year_ss: [2565, 2566, 2567, 2568, 2569, 2570],

      // Dialogs
      canceldialog: false,

      // Data
      conditons_transfer_successs: [], // Main List
      periods: {},
      transference_personnels_id_ref: {},
      conditons_transfer_successsSelect: {}, // Selected Item for action
      man_powerss: {},
      man_powerCan: {},
      man_power_cancel: {},

      // Table Config
      selectedHeaders: [],
      headersMap: [
        {
          text: "จัดการ",
          align: "center",
          value: "actionCencel",
          width: "80px"
        },
        { text: "สถานะ", align: "center", value: "ctsstatus_select" },
        { text: "ครั้งที่", align: "center", value: "ctstime_s" },
        { text: "ปีที่", align: "center", value: "ctsyear_s" },
        { text: "สังกัดใหม่", align: "left", value: "college_name_new" },
        { text: "เลขที่ตำแหน่งใหม่", align: "center", value: "ctsid_position" },
        {
          text: "ชื่อ-สกุล",
          align: "left",
          value: "frist_name",
          sortable: false
        }, // Combined in UI logic conceptually, keeping key
        { text: "สังกัดเดิม", align: "left", value: "college_name_old" },
        { text: "เลขที่เดิม", align: "left", value: "ctsid_postion_old" },
        { text: "จังหวัด", align: "left", value: "province_name" }, // Added assuming data exists or future use
        { text: "ช่วยราชการ", align: "center", value: "service_status" },
        { text: "เงื่อนไข", align: "center", value: "branch_name" },
        { text: "ID Card", align: "center", value: "ctsid_card" }
      ],

      snackbar: {
        show: false,
        color: "",
        timeout: 4000,
        icon: "",
        text: ""
      }
    };
  },
  computed: {
    showHeaders() {
      // Return headers based on selection, preserving order of headersMap
      return this.headersMap.filter(h => this.selectedHeaders.includes(h));
    },
    stats() {
      // Real-time calculation
      const total = this.conditons_transfer_successs.length;
      const agree = this.conditons_transfer_successs.filter(
        i => i.ctsstatus_select === "agree"
      ).length;
      const transfer = this.conditons_transfer_successs.filter(
        i => i.ctsstatus_select === "transfer"
      ).length;
      const swap = this.conditons_transfer_successs.filter(
        i =>
          i.ctsstatus_select === "sw_normal" ||
          i.ctsstatus_select === "sw_agree"
      ).length;

      return { total, agree, transfer, swap };
    }
  },
  created() {
    // Default headers to show
    const defaultKeys = [
      "actionCencel",
      "ctsstatus_select",
      "college_name_new",
      "ctsid_position",
      "frist_name",
      "college_name_old",
      "ctsid_postion_old"
    ];
    this.selectedHeaders = this.headersMap.filter(h =>
      defaultKeys.includes(h.value)
    );
  },
  async mounted() {
    await this.periodQuery();
    await this.conditons_transfer_successQueryAll();
  },
  methods: {
    // --- Data Fetching ---
    async periodQuery() {
      try {
        let result = await this.$http.post("period.php", {
          ApiKey: this.ApiKey,
          period_id: "301"
        });
        this.periods = result.data;
        // Auto select current period
        if (this.periods.period_times)
          this.times_select = this.periods.period_times;
        if (this.periods.period_year)
          this.years_select = this.periods.period_year;
      } catch (e) {
        console.error("Period Error", e);
      }
    },

    async conditons_transfer_successQueryAll() {
      this.loading = true;
      try {
        let result = await this.$http.post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          ctstime_s: this.periods.period_times,
          ctsyear_s: this.periods.period_year
        });
        this.conditons_transfer_successs = result.data;
      } catch (e) {
        this.showSnackbar("error", "โหลดข้อมูลไม่สำเร็จ");
      } finally {
        this.loading = false;
      }
    },

    async searchTimeYear() {
      this.loading = true;
      try {
        let result = await this.$http.post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          ctstime_s: this.times_select,
          ctsyear_s: this.years_select
        });
        this.conditons_transfer_successs = result.data;
        this.showSnackbar("success", `พบข้อมูล ${result.data.length} รายการ`);
      } catch (e) {
        this.showSnackbar("error", "ค้นหาล้มเหลว");
      } finally {
        this.loading = false;
      }
    },

    // --- Actions: Cancel Normal/Swap ---
    async CencelMovement(id_ref) {
      this.loading = true;
      try {
        // 1. Get Person Info
        let res_person = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          id_ref: id_ref
        });
        this.transference_personnels_id_ref = res_person.data;

        // 2. Get Manpower Info (Target)
        let res_man = await this.$http.post("man_power.php", {
          ApiKey: this.ApiKey,
          id_card: this.transference_personnels_id_ref.id_card
        });
        this.man_powerss = res_man.data;

        // 3. Get Success Record Info
        let res_cts = await this.$http.post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          ctsid_ref: id_ref
        });
        this.conditons_transfer_successsSelect = res_cts.data;

        this.canceldialog = true;
      } catch (e) {
        this.showSnackbar("error", "ดึงข้อมูลเพื่อยกเลิกไม่สำเร็จ");
      } finally {
        this.loading = false;
      }
    },

    async cancelSubmit() {
      try {
        // Prepare Manpower Update (Revert)
        this.man_powerCan.ApiKey = this.ApiKey;
        this.man_powerCan.status_booking = "";
        this.man_powerCan.id_position = this.man_powerss.id_position;

        // Prepare Manpower Delete (Target slot)
        this.man_power_cancel.ApiKey = this.ApiKey;
        this.man_power_cancel.id_position = this.conditons_transfer_successsSelect.ctsid_postion_old;

        if (this.man_powerss) {
          await this.$http.post(
            "man_power.update_process.php",
            this.man_powerCan
          );
        }

        let res_man_del = await this.$http.post(
          "man_power.delete.php",
          this.man_power_cancel
        );

        // Delete Success Record
        this.conditons_transfer_successsSelect.ApiKey = this.ApiKey;
        let res_cts = await this.$http.post(
          "conditons_transfer_success.delete.php",
          this.conditons_transfer_successsSelect
        );

        if (res_cts.data.status == true && res_man_del.data.status == true) {
          this.showSnackbar("success", "ยกเลิกและคืนสถานะเรียบร้อย");
          this.canceldialog = false;
          this.searchTimeYear(); // Refresh
        } else {
          this.showSnackbar("error", "เกิดข้อผิดพลาดในการบันทึก");
        }
      } catch (e) {
        this.showSnackbar("error", "Server Error");
      }
    },

    // --- Actions: Cancel Transfer (Cut) ---
    async CencelMovementCut(id_ref) {
      this.loading = true;
      try {
        let res_person = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          id_ref: id_ref
        });
        this.transference_personnels_id_ref = res_person.data;

        let res_cts = await this.$http.post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          ctsid_ref: id_ref
        });
        this.conditons_transfer_successsSelect = res_cts.data;

        this.canceldialog = true;
      } catch (e) {
        this.showSnackbar("error", "ดึงข้อมูลไม่สำเร็จ");
      } finally {
        this.loading = false;
      }
    },

    async cancelCutSubmit() {
      try {
        this.conditons_transfer_successsSelect.ApiKey = this.ApiKey;
        let result = await this.$http.post(
          "conditons_transfer_success.delete.php",
          this.conditons_transfer_successsSelect
        );

        if (result.data.status == true) {
          this.showSnackbar("success", "ยกเลิกรายการตัดโอนเรียบร้อย");
          this.canceldialog = false;
          this.searchTimeYear();
        } else {
          this.showSnackbar("error", "ลบข้อมูลล้มเหลว");
        }
      } catch (e) {
        this.showSnackbar("error", "Server Error");
      }
    },

    // --- Utilities ---
    exportToExcel() {
      const exportData = this.conditons_transfer_successs.map(item => ({
        ประเภท: this.getStatusText(item.ctsstatus_select),
        ครั้งที่: item.ctstime_s,
        ปีที่: item.ctsyear_s,
        "ชื่อ-สกุล": `${item.title_s}${item.frist_name} ${item.last_name}`,
        รหัสบัตรประชาชน: item.ctsid_card,
        สังกัดเดิม: item.college_name_old,
        เลขที่ตำแหน่งเดิม: item.ctsid_postion_old,
        สังกัดใหม่: item.college_name_new,
        เลขที่ตำแหน่งใหม่: item.ctsid_position,
        สาขา: item.branch_name
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Transfer_Success");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      const data = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
      });
      saveAs(
        data,
        `Transfer_Result_${this.times_select}_${this.years_select}.xlsx`
      );
    },

    getStatusColor(status) {
      if (status === "transfer") return "orange";
      if (status === "agree") return "success";
      if (status === "demand") return "purple";
      if (status === "sw_normal" || status === "sw_agree") return "cyan";
      return "grey";
    },

    getStatusText(status) {
      if (status === "transfer") return "ตัดโอน";
      if (status === "agree") return "ย้ายปกติ";
      if (status === "demand") return "ประสงค์รับ";
      if (status === "sw_normal") return "สับเปลี่ยน (ปกติ)";
      if (status === "sw_agree") return "สับเปลี่ยน (แลกเปลี่ยน)";
      return status;
    },

    row_classes(item) {
      // Optional: Highlight rows if needed
      return "";
    },

    showSnackbar(color, text) {
      this.snackbar.color = color;
      this.snackbar.text = text;
      this.snackbar.icon =
        color === "success" ? "mdi-check-circle" : "mdi-alert-circle";
      this.snackbar.show = true;
    }
  }
};
</script>

<style scoped>
/* Custom minimal styling */
</style>
